import TemplateView from "../../TemplateView";
import WorkflowStatusTimeColumn from "./WorkflowStatusTimeColumn";
import {WorkflowStatusType} from "../../workflowStatus/constants";
import UserTime from "../../user_time";
import messageResource from "../../messageResource";

export default class ProjectPanelTimeDetails extends TemplateView {
    constructor() {
        super();
        this.state = {
            totalTime: 0,
            totalOpenTime: 0,
            totalCompletedTime: 0,
            statuses: [],
            timeByStatuses: null,
            showDetailedInfo: false
        };

        this.onStateChanged(() => this.updateView());
    }

    templateHtml() {
        return "<div class='timeDetails'>" +
               "  <div class='totalSpent'>" +
               "    <div class='title'><%-title%></div>" +
               "    <div class='time'></div>" +
               "  </div>" +
               "  <div class='timeTable'>" +
               "    <div class='timeColumn open'></div>" +
               "    <div class='timeColumn completed'></div>" +
               "  </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            title: "project.edit_panel.total_spent_time"
        }
    }

    afterRender() {
        this.$totalTime = this.find(".totalSpent .time");

        this.$openColumn = this.find(".timeColumn.open");
        this.$completedColumn = this.find(".timeColumn.completed");
        this.openColumn = new WorkflowStatusTimeColumn().init(this.$openColumn);
        this.completedColumn = new WorkflowStatusTimeColumn().init(this.$completedColumn);
    }

    updateView() {
        this.$totalTime.text(UserTime.formatTimeWithDigitSeparator(this.state.totalTime));
        let openStatuses = [];
        let completedStatuses = [];
        let showOpenColumn = true;
        let showCompletedColumn = true;
        let openTaskTitle = "project.edit_panel.open_spent_time";
        let completedTaskTitle = "project.edit_panel.completed_spent_time";

        if (this.state.showDetailedInfo) {
            showCompletedColumn = this.state.totalCompletedTime > 0;
            showOpenColumn = this.state.totalOpenTime > 0;
            // TODO bakharev: add sorting by position
            openStatuses = this.state.statuses.filter((status) => status.type === WorkflowStatusType.OPEN);
            completedStatuses = this.state.statuses.filter((status) => status.type === WorkflowStatusType.COMPLETED);
            openTaskTitle = "workflow_list.open_tasks";
            completedTaskTitle = "workflow_list.completed_tasks";

            this.$openColumn.toggle(showOpenColumn);
            this.$completedColumn.toggle(showCompletedColumn);
        }
        this.openColumn.setState({
            title: messageResource.getMessage(openTaskTitle),
            statuses: openStatuses,
            time: this.state.timeByStatuses,
            totalTime: this.state.totalOpenTime
        });
        this.completedColumn.setState({
            title: messageResource.getMessage(completedTaskTitle),
            statuses: completedStatuses,
            time: this.state.timeByStatuses,
            totalTime: this.state.totalCompletedTime
        });

        this.$el.toggleClass("shortInfo", !this.state.showDetailedInfo);
        this.$el.toggleClass("detailedInfo", this.state.showDetailedInfo);
    }

}


// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanelTimeDetails.js